import {Component} from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {LayoutSplashScreen} from "../../../../_metronic/layout";
import * as auth from "../_redux/authRedux";
import { logout } from "../_redux/authCrud";

class Logout extends Component {
  componentDidMount() {
    logout().then(() => this.props.logout());
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/giris-yap" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.user) }),
  auth.actions
)(Logout);